// import React, { useState, useEffect } from 'react';
// import { Helmet } from 'react-helmet-async';
// import PageTitle from 'src/components/PageTitle';
// import PageTitleWrapper from 'src/components/PageTitleWrapper';
// import { DataGrid, GridToolbar } from '@mui/x-data-grid';
// import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from '@mui/material';
// import DatePicker from '@mui/lab/DatePicker';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import axios from 'axios';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { blue, red } from '@mui/material/colors';
// import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { Doughnut } from 'react-chartjs-2';
// import 'chart.js/auto';


// const Platforms = () => {
//     const styles = {
//         sectionContainer: {
//           marginBottom: '20px',
//           border: '1px solid #ccc',
//           borderRadius: '5px',
//           marginLeft: '800px', // Adjust the left margin as needed
//         },
//         featureList: {
//           listStyleType: 'none',
//           paddingLeft: '0',
//         },
//         featureTitle: {
//           fontWeight: 'bold',
//           marginBottom: '5px',
//         },
//         accordionTitle: {
//           fontWeight: 'bold',
//         },
//         tabContainer: {
//           display: 'flex',
//           flexDirection: 'column',
//           marginRight: '10px',
//         },
//         tabButton: {
//           marginBottom: '10px',
//         },
//         contentContainer: {
//           flex: 1,
//           marginLeft: '20px', 
//         },
//         inputContainer: {
//           marginBottom: '30px', 
//         },
//         submitButton: {
//           marginTop: '10px',
//         },
        
//       };
    
//       const [tab, setTab] = useState('Year');
    
//       const handleTabChange = (newTab) => {
//         setTab(newTab);
//       };
//       const [startDate, setStartDate] = useState(new Date());
//       const [endDate, setEndDate] = useState(new Date());
//       const [selectedType, setSelectedType] = useState('');
    
//       const [selectedYear, setSelectedYear] = useState('');
//       const [selectedMonth, setSelectedMonth] = useState('');


//       const pieChartData = {
//         labels: ['Diveces'],
//         datasets: [
//           {
//             data: [40], // Adjust this value as needed
//             backgroundColor: [ '#36A2EB'], // Colors for each segment
//             hoverBackgroundColor: [ '#36A2EB'], // Hover colors for each segment
//           },
//         ],
//       };
      
    



//       const generateYears = () => {
//         const currentYear = new Date().getFullYear();
//         return Array.from({ length: currentYear - 1900 + 1 }, (_, i) => ({
//           value: (currentYear - i).toString(),
//           label: (currentYear - i).toString(),
//         }));
//       };


//       //Gerated Month
//     const generateMonths = () => [
//         { value: 'January', label: 'January' },
//         { value: 'February', label: 'February' },
//         { value: 'March', label: 'March' },
//         { value: 'April', label: 'April' },
//         { value: 'May', label: 'May' },
//         { value: 'June', label: 'June' },
//         { value: 'July', label: 'July' },
//         { value: 'August', label: 'August' },
//         { value: 'September', label: 'September' },
//         { value: 'October', label: 'October' },
//         { value: 'November', label: 'November' },
//         { value: 'December', label: 'December' },
//       ];
    
//       const renderTabContent = () => {
//         switch (tab) {
//             case 'Year':
//               return (
//                 <div>
//                   <Box sx={styles.inputContainer}>
//                     <InputLabel>Year</InputLabel>
//                     <Select
//                       value={selectedYear}
//                       onChange={(e) => setSelectedYear(e.target.value)}
//                       label="Year"
//                       sx={{ width: '270px' }}
//                     >
//                       {generateYears().map((year) => (
//                         <MenuItem key={year.value} value={year.value}>
//                           {year.label}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </Box>
//                   <Box sx={styles.inputContainer}>
//               <InputLabel>Type</InputLabel>
//               <Select
//                 value={selectedType}
//                 onChange={(e) => setSelectedType(e.target.value)}
//                 label="Type"
//                 sx={{ width: '270px'}}
//               >
//                 <MenuItem value="HoursofView">Hours Of View</MenuItem>
//                 <MenuItem value="NumbersofView">Numbers Of View</MenuItem>
//                 {/* Add more types as needed */}
//               </Select>
//             </Box>
//             <Box sx={styles.inputContainer}>
//                   <InputLabel>Country</InputLabel>
//                   <Select
//                 value={selectedType}
//                 onChange={(e) => setSelectedType(e.target.value)}
//                 label="Type"
//                 sx={{ width: '270px'}}
//               >
//                 <MenuItem value="option1">Option 1</MenuItem>
//                 <MenuItem value="option2">Option 2</MenuItem>
//                 {/* Add more types as needed */}
//               </Select>
//                 </Box>
//                 <Box sx={styles.inputContainer}>
//                   <InputLabel>Content Type</InputLabel>
//                   <Select
//                 value={selectedType}
//                 onChange={(e) => setSelectedType(e.target.value)}
//                 label="Type"
//                 sx={{ width: '270px'}}
//               >
//                 <MenuItem value="channels">Channels</MenuItem>
//                 <MenuItem value="audio">Audio</MenuItem>
//                 <MenuItem value="Video">Video</MenuItem>
//                 {/* Add more types as needed */}
//               </Select>
//                 </Box>
//                 <Button variant="contained" color="primary" sx={styles.submitButton}>
//                   Submit
//                 </Button>
//               </div>
//             );
//           case 'Month':
//             return (
//               <div>
//                 <Box sx={styles.inputContainer}>
//                     <InputLabel>Year</InputLabel>
//                     <Select
//                       value={selectedYear}
//                       onChange={(e) => setSelectedYear(e.target.value)}
//                       label="Year"
//                       sx={{ width: '270px' }}
//                     >
//                       {generateYears().map((year) => (
//                         <MenuItem key={year.value} value={year.value}>
//                           {year.label}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </Box>
//                   <Box sx={styles.inputContainer}>
//               <InputLabel>Month</InputLabel>
//               <Select
//                 value={selectedMonth}
//                 onChange={(e) => setSelectedMonth(e.target.value)}
//                 label="Month"
//                 sx={{ width: '270px' }}
//               >
//                 {generateMonths().map((month) => (
//                   <MenuItem key={month.value} value={month.value}>
//                     {month.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//               <Box sx={styles.inputContainer}>
//                   <InputLabel>Country</InputLabel>
//                   <Select
//                 value={selectedType}
//                 onChange={(e) => setSelectedType(e.target.value)}
//                 label="Type"
//                 sx={{ width: '270px'}}
//               >
//                 <MenuItem value="option1">Option 1</MenuItem>
//                 <MenuItem value="option2">Option 2</MenuItem>
//                 {/* Add more types as needed */}
//               </Select>
//                 </Box>
//             </Box>
//                 <Box sx={styles.inputContainer}>
//               <InputLabel>Type</InputLabel>
//               <Select
//                 value={selectedType}
//                 onChange={(e) => setSelectedType(e.target.value)}
//                 label="Type"
//                 sx={{ width: '270px'}}
//               >
//                 <MenuItem value="HoursofView">Hours Of View</MenuItem>
//                 <MenuItem value="NumbersofView">Numbers Of View</MenuItem>
//                 {/* Add more types as needed */}
//               </Select>
//             </Box>
               
//                 <Box sx={styles.inputContainer}>
//                   <InputLabel>Content Type</InputLabel>
//                   <Select
//                 value={selectedType}
//                 onChange={(e) => setSelectedType(e.target.value)}
//                 label="Type"
//                 sx={{ width: '270px'}}
//               >
//                 <MenuItem value="channels">Channels</MenuItem>
//                 <MenuItem value="audio">Audio</MenuItem>
//                 <MenuItem value="Video">Video</MenuItem>
//                 {/* Add more types as needed */}
//               </Select>
//                 </Box>
//                 <Button variant="contained" color="primary" sx={styles.submitButton}>
//                   Submit
//                 </Button>
//               </div>
//             );
//           case 'Days':
//             return (
//               <div>
//                 <Box sx={styles.inputContainer}>
//               <InputLabel>Start Date</InputLabel>
//               <LocalizationProvider dateAdapter={AdapterDateFns}>
//                 <DatePicker
//                   value={startDate}
//                   onChange={(date) => setStartDate(date)}
//                   renderInput={(params) => <TextField {...params} />}
//                 />
//               </LocalizationProvider>
//             </Box>
//                 <Box sx={styles.inputContainer}>
//                   <InputLabel>End Date</InputLabel>
//                   <LocalizationProvider dateAdapter={AdapterDateFns}>
//                 <DatePicker
//                   value={endDate}
//                   onChange={(date) => setEndDate(date)}
//                   renderInput={(params) => <TextField {...params} />}
//                 />
//               </LocalizationProvider>
//                 </Box>
//                 <Box sx={styles.inputContainer}>
//               <InputLabel>Type</InputLabel>
//               <Select
//                 value={selectedType}
//                 onChange={(e) => setSelectedType(e.target.value)}
//                 label="Type"
//                 sx={{ width: '270px'}}
//               >
//                 <MenuItem value="HoursofView">Hours Of View</MenuItem>
//                 <MenuItem value="NumbersofView">Numbers Of View</MenuItem>
//                 {/* Add more types as needed */}
//               </Select>
//             </Box>
//                 <Box sx={styles.inputContainer}>
//                   <InputLabel>Country</InputLabel>
//                   <Select
//                 value={selectedType}
//                 onChange={(e) => setSelectedType(e.target.value)}
//                 label="Type"
//                 sx={{ width: '270px'}}
//               >
//                 <MenuItem value="option1">Option 1</MenuItem>
//                 <MenuItem value="option2">Option 2</MenuItem>
//                 {/* Add more types as needed */}
//               </Select>
//                 </Box>
//                 <Box sx={styles.inputContainer}>
//                   <InputLabel>Content Type</InputLabel>
//                   <Select
//                 value={selectedType}
//                 onChange={(e) => setSelectedType(e.target.value)}
//                 label="Type"
//                 sx={{ width: '270px'}}
//               >
//                 <MenuItem value="channels">Channels</MenuItem>
//                 <MenuItem value="audio">Audio</MenuItem>
//                 <MenuItem value="Video">Video</MenuItem>
//                 {/* Add more types as needed */}
//               </Select>
//                 </Box>
//                 <Button variant="contained" color="primary" sx={styles.submitButton}>
//                   Submit
//                 </Button>
//               </div>
//             );
//           default:
//             return null;
//         }
//       };
    
//       return (
//         <div>
//           <Box sx={{ display: 'flex' }}>
//             <Box sx={{ flex: 1, marginRight: '20px' }}>
//               {/* Include your pie chart component here */}
//               <Doughnut
//   data={pieChartData}
//   options={{
//     aspectRatio: 1,
//     plugins: {
//       legend: {
//         display: true,
//         position: 'bottom', // You can adjust the position as needed
//       },
//     },
//     elements: {
//       arc: {
//         borderWidth: 0, // Set the border width to 0 to remove borders
//       },
//     },
//     radius: '89%', // Adjust the radius as needed (percentage of available space)
//   }}
// />


//             </Box>
//             <Accordion sx={styles.sectionContainer} defaultExpanded={true}>
//               <AccordionSummary
//                 expandIcon={<ExpandMoreIcon />}
//                 aria-controls="Watching-by-Countries-content"
//                 id="Watching-by-Countries-header"
//               >
//                 <Typography variant="h5" sx={styles.accordionTitle}>
//                   Watching by Platform
//                 </Typography>
//               </AccordionSummary>
//               <AccordionDetails>
//                 <Box>
//                   <div>
//                     <Button sx={styles.tabButton} onClick={() => handleTabChange('Year')}>
//                       Year
//                     </Button>
//                     <Button sx={styles.tabButton} onClick={() => handleTabChange('Month')}>
//                       Month
//                     </Button>
//                     <Button sx={styles.tabButton} onClick={() => handleTabChange('Days')}>
//                       Days
//                     </Button>
//                   </div>
//                   <Box sx={styles.contentContainer}>
//                     {renderTabContent()}
//                   </Box>
//                 </Box>
//               </AccordionDetails>
//             </Accordion>
//           </Box>
//         </div>
//       );
      
//     };
// export default Platforms;



import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Platforms = () => {
  const styles = {
    sectionContainer: {
      marginBottom: '20px',
      border: '1px solid #ccc',
      borderRadius: '5px',
    },
    accordionTitle: {
      fontWeight: 'bold',
    },
    comingSoonContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '400px',
      width: '100%'
    },
    comingSoonText: {
      fontWeight: 'bold',
      fontSize: '2.5rem'
    }
  };

  return (
    <div>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ flex: 1, marginRight: '20px' }}>
          {/* Placeholder for where chart would be */}
          <Box sx={styles.comingSoonContainer}>
            <Typography variant="h2" sx={styles.comingSoonText}>
              Coming Soon
            </Typography>
          </Box>
        </Box>
      
      </Box>
    </div>
  );
};

export default Platforms;